import React, { createContext, useContext, useEffect } from "react";

/* La charte du back-office n'a qu'une variante, claire : le basculement
   sombre/clair est retiré. Le contexte reste exposé (mode toujours « light »,
   bascule sans effet) pour les écrans qui le lisent encore. L'ancienne
   préférence `tribe-theme` du navigateur est ignorée. */
export type ThemeMode = "dark" | "light";

interface ThemeContextValue {
  mode: ThemeMode;
  toggle: () => void;
}

const ThemeContext = createContext<ThemeContextValue>({
  mode: "light",
  toggle: () => {},
});

export const useThemeMode = () => useContext(ThemeContext);

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", "light");
  }, []);

  return (
    <ThemeContext.Provider value={{ mode: "light", toggle: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
}
